import React from "react";
import { FiUser, FiClock } from "react-icons/fi";

export default function TeamAttendance() {
  const attendance = [
    { name: "Rahul Kumar", in: "09:05 AM", out: "06:10 PM", status: "Present" },
    { name: "Priya Sharma", in: "-", out: "-", status: "Absent" },
  ];

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Team Attendance</h2>

      <div className="bg-white shadow rounded-xl">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-100 border-b">
              <th className="p-3 text-left">Employee</th>
              <th className="p-3 text-left">In Time</th>
              <th className="p-3 text-left">Out Time</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>

          <tbody>
            {attendance.map((a, i) => (
              <tr key={i} className="border-b">
                <td className="p-3 flex items-center gap-2"><FiUser /> {a.name}</td>
                <td className="p-3">{a.in}</td>
                <td className="p-3">{a.out}</td>
                <td className={`p-3 font-semibold ${a.status === "Present" ? "text-green-600" : "text-red-600"}`}>
                  {a.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
